/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { AnalysisResultDtoAreaFlatness } from './AnalysisResultDtoAreaFlatness';
import {
    AnalysisResultDtoAreaFlatnessFromJSON,
    AnalysisResultDtoAreaFlatnessFromJSONTyped,
    AnalysisResultDtoAreaFlatnessToJSON,
} from './AnalysisResultDtoAreaFlatness';
import type { AnalysisResultDtoAirPressureFault } from './AnalysisResultDtoAirPressureFault';
import {
    AnalysisResultDtoAirPressureFaultFromJSON,
    AnalysisResultDtoAirPressureFaultFromJSONTyped,
    AnalysisResultDtoAirPressureFaultToJSON,
} from './AnalysisResultDtoAirPressureFault';
import type { ProfileAnalysisResultDtoCaxDeviation } from './ProfileAnalysisResultDtoCaxDeviation';
import {
    ProfileAnalysisResultDtoCaxDeviationFromJSON,
    ProfileAnalysisResultDtoCaxDeviationFromJSONTyped,
    ProfileAnalysisResultDtoCaxDeviationToJSON,
} from './ProfileAnalysisResultDtoCaxDeviation';

/**
 * 
 * @export
 * @interface ProfileAnalysisResultDto
 */
export interface ProfileAnalysisResultDto {
    /**
     * 
     * @type {string}
     * @memberof ProfileAnalysisResultDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileAnalysisResultDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof ProfileAnalysisResultDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileAnalysisResultDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProfileAnalysisResultDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileAnalysisResultDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProfileAnalysisResultDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileAnalysisResultDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileAnalysisResultDto
     */
    creatorUser?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileAnalysisResultDto
     */
    lastModifierUser?: string | null;
    /**
     * 
     * @type {ProfileAnalysisResultDtoCaxDeviation}
     * @memberof ProfileAnalysisResultDto
     */
    caxDeviation?: ProfileAnalysisResultDtoCaxDeviation | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof ProfileAnalysisResultDto
     */
    caxDeviationFault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {AnalysisResultDtoAreaFlatness}
     * @memberof ProfileAnalysisResultDto
     */
    flatness?: AnalysisResultDtoAreaFlatness | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof ProfileAnalysisResultDto
     */
    flatnessFault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {ProfileAnalysisResultDtoCaxDeviation}
     * @memberof ProfileAnalysisResultDto
     */
    radiationFieldSize?: ProfileAnalysisResultDtoCaxDeviation | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof ProfileAnalysisResultDto
     */
    radiationFieldSizeFault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {AnalysisResultDtoAreaFlatness}
     * @memberof ProfileAnalysisResultDto
     */
    stabilityIndex?: AnalysisResultDtoAreaFlatness | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof ProfileAnalysisResultDto
     */
    stabilityIndexFault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {AnalysisResultDtoAreaFlatness}
     * @memberof ProfileAnalysisResultDto
     */
    symmetry?: AnalysisResultDtoAreaFlatness | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof ProfileAnalysisResultDto
     */
    symmetryFault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileAnalysisResultDto
     */
    $type?: ProfileAnalysisResultDtoTypeEnum;
}


/**
 * @export
 */
export const ProfileAnalysisResultDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedAnalysisComponentDtoProfileAnalysisResultDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.AnalysisComponent.Dto.ProfileAnalysisResultDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ProfileAnalysisResultDtoTypeEnum = typeof ProfileAnalysisResultDtoTypeEnum[keyof typeof ProfileAnalysisResultDtoTypeEnum];



/**
 * Check if a given object implements the ProfileAnalysisResultDto interface.
 */
export function instanceOfProfileAnalysisResultDto(value?: unknown): value is ProfileAnalysisResultDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ProfileAnalysisResultDtoTypeEnum)[0];
}

export function ProfileAnalysisResultDtoFromJSON(json: any): ProfileAnalysisResultDto {
    return ProfileAnalysisResultDtoFromJSONTyped(json, false);
}

export function ProfileAnalysisResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileAnalysisResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'isDeleted': json['isDeleted'] == null ? undefined : json['isDeleted'],
        'deleterUserId': json['deleterUserId'] == null ? undefined : json['deleterUserId'],
        'deletionTime': json['deletionTime'] == null ? undefined : json['deletionTime'],
        'creatorUser': json['creatorUser'] == null ? undefined : json['creatorUser'],
        'lastModifierUser': json['lastModifierUser'] == null ? undefined : json['lastModifierUser'],
        'caxDeviation': json['caxDeviation'] == null ? undefined : ProfileAnalysisResultDtoCaxDeviationFromJSON(json['caxDeviation']),
        'caxDeviationFault': json['caxDeviationFault'] == null ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['caxDeviationFault']),
        'flatness': json['flatness'] == null ? undefined : AnalysisResultDtoAreaFlatnessFromJSON(json['flatness']),
        'flatnessFault': json['flatnessFault'] == null ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['flatnessFault']),
        'radiationFieldSize': json['radiationFieldSize'] == null ? undefined : ProfileAnalysisResultDtoCaxDeviationFromJSON(json['radiationFieldSize']),
        'radiationFieldSizeFault': json['radiationFieldSizeFault'] == null ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['radiationFieldSizeFault']),
        'stabilityIndex': json['stabilityIndex'] == null ? undefined : AnalysisResultDtoAreaFlatnessFromJSON(json['stabilityIndex']),
        'stabilityIndexFault': json['stabilityIndexFault'] == null ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['stabilityIndexFault']),
        'symmetry': json['symmetry'] == null ? undefined : AnalysisResultDtoAreaFlatnessFromJSON(json['symmetry']),
        'symmetryFault': json['symmetryFault'] == null ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['symmetryFault']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ProfileAnalysisResultDtoToJSON(value?: Omit<ProfileAnalysisResultDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'|'isDeleted'|'deleterUserId'|'deletionTime'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'creatorUser': value['creatorUser'],
        'lastModifierUser': value['lastModifierUser'],
        'caxDeviation': ProfileAnalysisResultDtoCaxDeviationToJSON(value['caxDeviation']),
        'caxDeviationFault': AnalysisResultDtoAirPressureFaultToJSON(value['caxDeviationFault']),
        'flatness': AnalysisResultDtoAreaFlatnessToJSON(value['flatness']),
        'flatnessFault': AnalysisResultDtoAirPressureFaultToJSON(value['flatnessFault']),
        'radiationFieldSize': ProfileAnalysisResultDtoCaxDeviationToJSON(value['radiationFieldSize']),
        'radiationFieldSizeFault': AnalysisResultDtoAirPressureFaultToJSON(value['radiationFieldSizeFault']),
        'stabilityIndex': AnalysisResultDtoAreaFlatnessToJSON(value['stabilityIndex']),
        'stabilityIndexFault': AnalysisResultDtoAirPressureFaultToJSON(value['stabilityIndexFault']),
        'symmetry': AnalysisResultDtoAreaFlatnessToJSON(value['symmetry']),
        'symmetryFault': AnalysisResultDtoAirPressureFaultToJSON(value['symmetryFault']),
        '$type': value['$type'],
    });
}

